import { Trophy } from 'lucide-react';
import { cn } from '@/lib/utils';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

interface MentorFoundingMemberBadgeProps {
  isFoundingMember?: boolean;
  className?: string;
}

export function MentorFoundingMemberBadge({
  isFoundingMember,
  className,
}: MentorFoundingMemberBadgeProps) {
  if (!isFoundingMember) return null;

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            className={cn('inline-flex text-purple-400', className)}
            data-testid="mentor-founding-member-badge"
          >
            <Trophy className="w-4 h-4 shrink-0" />
          </span>
        </TooltipTrigger>
        <TooltipContent>
          <p>Founding Member</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
